var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap", attrs: { id: "voiceSceneTeacherDetail" } },
    [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "btn-box" }, [
          _vm.preId != null
            ? _c("div", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.toPre(_vm.preId)
                      }
                    }
                  },
                  [_vm._v("上一通练习")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.preId == null
            ? _c("div", [
                _c("a", { staticClass: "isgrey" }, [_vm._v("上一通练习")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.nextId != null
            ? _c("div", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.toNext(_vm.nextId)
                      }
                    }
                  },
                  [_vm._v("下一通练习")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.nextId == null
            ? _c("div", [
                _c("a", { staticClass: "isgrey" }, [_vm._v("下一通练习")])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }, [
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("h3", [
              _vm._v(_vm._s(_vm.existAdvise ? "练习得分与建议" : "练习得分"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "video ivideo" }, [
              _c("span", [_vm._v("练习录音")]),
              _vm._v(" "),
              _c("audio", {
                attrs: { src: _vm.videoUrl, controls: "controls" }
              })
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "practice" }, [
              _vm._v(
                "\n\t\t\t\t\t\t\t练习评分(" +
                  _vm._s(_vm.gradeScore) +
                  ")\n\t\t\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.gradeList,
                  "span-method": _vm.objectSpanMethod,
                  "header-cell-style": _vm.rowClass,
                  "cell-class-name": _vm.addClass,
                  border: ""
                }
              },
              [
                _c(
                  "el-table-column",
                  { attrs: { label: "练习内容", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "parentname",
                        width: "110",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "name", width: "150", align: "center" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gradeScore",
                    label: "总分",
                    width: "80",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { label: "自评分", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: { label: "扣分", align: "center", width: "auto" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "textstyle text-style" },
                                    [
                                      scope.row.gradeScore - scope.row.score !=
                                      0
                                        ? _c(
                                            "span",
                                            { staticClass: "DeductPoints" },
                                            [
                                              _vm._v(
                                                "-" +
                                                  _vm._s(
                                                    scope.row.gradeScore -
                                                      scope.row.score
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "DeductionDetails" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(scope.row.checkedName) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [_vm._v(_vm._s(scope.row.checkedName))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "score",
                        label: "得分",
                        width: "80",
                        align: "center"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.existAdvise
                  ? _c("el-table-column", {
                      attrs: { label: "练习建议", align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("div", { staticClass: "text-style" }, [
                                      _c("span", { staticClass: "isred" }, [
                                        _vm._v(_vm._s(scope.row.description))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content"
                                      },
                                      [_vm._v(_vm._s(scope.row.description))]
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        475786103
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa25fe9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa25fe9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/record/eachRecordDetail.vue
// module id = 1624
// module chunks = 0